<template>
    <div class="container">
        <div class="backroute" @click.stop="router.push(`/course/${route.params.courseId}/module/${route.params.moduleId}/activity/attach/${route.params.contentId}`)"><i class="material-icons">keyboard_arrow_left</i><span>{{ $t('attachUserHistory.BACK') }}</span></div>

        <template v-if="dataLoaded">
            <div class="history__status">
                <h3>{{ $t('attachUserHistory.DELIVERY_DETAIL') }}</h3>
                <span>{{ $t('attachUserHistory.ACTIVITY_STATUS') }}: <strong :class="{ 'open': userData.activityStatusCode === 'OPEN' }">{{ userData.activityStatus }}</strong></span>
            </div>
            <div class="user-info tutor__infoCard">
                <span class="user-info__name"><strong>{{ $t('global.PARTICIPANT') }}: </strong>{{userData.userInfo.firstName}} {{userData.userInfo.lastName}}</span>
                <div class="user-info__status">
                    <strong>{{ $t('global.STATE') }}:</strong>
                    <span :class="{'NotFinished--a': userData.userInfo.status == 'NotFinished', 'FinishedOutOfTime--a': userData.userInfo.status === 'FinishedOutOfTime', 'FinishedInTime--a': userData.userInfo.status === 'FinishedInTime'}">
                        {{$t(`tutor.detail.status.${userData.userInfo.status}`)}}
                    </span>
                    <span v-if="userData.userInfo.status == 'NotFinished'">
                        {{userData.userInfo.timeDiffValue ? $t('global.EXPIRES_IN') + userData.userInfo.timeDiffValue + ' ' + $t(`date.params.${userData.userInfo.timeDiffParam}`) : $t('global.EXPIRED')}}
                    </span>
                    <span v-if="userData.userInfo.status == 'FinishedOutOfTime'">
                        {{userData.userInfo.timeDiffValue + ' ' + $t(`date.params.${userData.userInfo.timeDiffParam}`) + + ' ' + $t('global.LATE')}}
                    </span>
                </div> 

                <span class="user-info__mail" ><strong>{{ $t('global.EMAIL') }}: </strong>{{userData.userInfo.email}}</span>
                <div><span><strong>{{ $t('attachUserHistory.LAST_MODIFICATION') }}: </strong></span><span>{{userData.userInfo.lastSeen ? formatDate(userData.userInfo.lastSeen) : $t('global.NEVER')}}</span></div>
                <div class="user-info__attaches">
                    <span><strong>{{ $t('attachUserHistory.FILES') }}: </strong></span>
                    <div class="files">
                        <a v-for="(file,idx) in lastSubmission.attach" :key="idx" :href="getFile(file.file,'activity')" target="_blank">
                            <i class="material-icons">attach_file</i>
                            <span>{{file.originalFileName}}</span>
                        </a>
                    </div>
                </div>
            </div>

            <h3>{{ $t('attachUserHistory.DELIVERIES_HISTORY') }}</h3>
            <div class="submissions tutor__infoCard ">
                <div id="messageBox" >
                    <template v-if="userData.histories.length > 0" >
                        <div class="history__container">
                            <div class="history__component" :class="[submission.attach.length >= 1 && 'history__component--attach', submission.isFeedbackFromForge && 'feedback']" v-for="(submission, index) in userData.histories" :key="index" >
                                <template class="history__newAttach--container" v-if="!submission.isFeedbackFromForge">
                                    <div class="history__newAttach">
                                        <div>
                                            <span><strong>{{ userData.userInfo.firstName }}</strong> {{ $t('attachUserHistory.HAS_MADE_A_NEW_DELIVERY') }}</span>
                                            <span class="history__date" >{{ formatDate(submission.submissionDate) }}.</span>
                                        </div>
                                        <div class="history__attach" v-if="submission.attach.length >= 1">
                                            <div class="files">
                                                <a v-for="(file, index) in submission.attach" :key="index" :href="getFile(file.file, 'activity')" target="_blanck" >
                                                    <i class="material-icons">attach_file</i>
                                                    <span>{{file.originalFileName}}</span>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="history__submission">
                                            <div class="history__message" v-html="submission.answer" ></div>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div>
                                        <span class="history__autor" >{{ submission.createdBy }}</span>
                                        <span class="history__date">{{formatDate(submission.submissionDate)}}</span>
                                    </div>
                                    <div class="history__submission">
                                        <div class="history__message" v-html="submission.message" ></div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </template>
                    <EmptyState v-else-if="user.role.toLowerCase() === 'learninguser'" :icon="'text_snippet'" :title="$t('attachUserHistory.NO_FILES_UPLOADED_TITLE')"  />
                    <EmptyState v-else  :icon="'text_snippet'" :color="'pink'" :title="$t('attachUserHistory.NO_FILES_UPLOADED_TITLE')" :message="$t('attachUserHistory.NO_FILES_UPLOADED_MESSAGE')" />

                </div>
            </div>
            <div v-if="user.permissions.includes('CURSO_ACTIVIDAD_FEEDBACK_CREACION')"> 
                <h3>{{ $t('attachUserHistory.YOUR_FEEDBACK') }}</h3>
                <div @submit.prevent="onSubmit()" class="history__form tutor__infoCard" >
                    <div class="new-feedback">
                        <vue-editor
                        v-model="feedbackModel.message"
                        :editor-toolbar="customToolbar"
                        :editorOptions="editorSettings"
                        /> 
                        <div class="new-feedback__actions">
                            <button class="cancel" @click.stop="feedbackModel.message = ''; ">{{$t('global.CANCEL')}}</button>
                            <button :disabled="!submitMessageLoaded" class="confirm" @click.stop="onSubmit()" type="submit">{{ $t('global.SEND') }} <i class="material-icons-outlined">arrow_forward</i></button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <div v-else>{{ $t('attachUserHistory.LOADING_INFORMATION') }}</div>
    </div>

    
</template>

<script>
import { useRoute, useRouter } from 'vue-router';
import { onMounted, ref, inject, onUpdated, computed } from 'vue';
import { useStore } from 'vuex';
import { VueEditor, Quill } from "vue3-editor";
import Emoji from "quill-emoji/dist/quill-emoji";
Quill.register("modules/emoji", Emoji);
import EmptyState from '../../components/EmptyState.vue';
import { useI18n } from 'vue-i18n';

export default {
    setup() {
        const { t } = useI18n();
        const route = useRoute();
        const router = useRouter();
        const store = useStore();
        const formatDate = inject("formatDate");
        const getFile = inject("getFile");
        const user = computed(() => store.getters.manageUser_user);
        const userData = ref();
        const lastSubmission = ref(null);
        const dataLoaded = ref(false);
        const submitMessageLoaded = ref(true)
        const feedbackModel = ref({
            contentId: route.params.contentId,
            learningUsers: [route.params.userId],
            message: ""
        });
        async function getUserData(message) {
            if (!message)
                dataLoaded.value = false;
            try {
                let req = await store.dispatch("activities_attachUserHistory", { contentId: route.params.contentId, userId: route.params.userId });
                userData.value = req.data;
                // userData.value.activityStatus = userData.value.userInfo.status === 'FinishedOutOfTime' || (userData.value.userInfo.status === 'NotFinished' && !userData.value.userInfo.timeDiffValue ) ? 'Vencida' : 'Abierta'
                userData.value.activityStatusCode = userData.value.userInfo.status === 'FinishedOutOfTime' || (userData.value.userInfo.status === 'NotFinished' && !userData.value.userInfo.timeDiffValue ) ? 'EXPIRED' : 'OPEN';
                userData.value.activityStatus = t(`attachUserHistory.${userData.value.activityStatusCode}`);

                Array.isArray(userData.value.submissions) ? lastSubmission.value = userData.value.submission[userData.value.submission.length - 1] : lastSubmission.value = [];
                dataLoaded.value = true;
            }
            catch (error) {
                console.log(error);
            }
        }
        const onSubmit = async () => {
            if (feedbackModel.value.message.trim().length < 1) {
                feedbackModel.value.message = "";
                return;
            }
            else {
                submitMessageLoaded.value = false
                await store.dispatch("activities_attachPostFeedback", feedbackModel.value);
                getUserData(true);
                feedbackModel.value.message = "";
                submitMessageLoaded.value = true
            }
        };
        onMounted(() => {
            if (!user.value.permissions.includes('CURSO_ACTIVIDAD_DETALLE')) return
            getUserData();
        });
        onUpdated(() => {
            // Setea el scroll hacia abajo para que aparezca el ultimo mensaje enviado.
            let messageBox = document.getElementById("messageBox");
            if (messageBox)
                messageBox.scrollTop = messageBox.scrollHeight;
        });
        return {
            route,
            router,
            formatDate,
            getFile,
            userData,
            lastSubmission,
            dataLoaded,
            feedbackModel,
            submitMessageLoaded,
            onSubmit,
            user,
            t,
            customToolbar: [
            ["bold", "italic", "underline", "strike"],
            [{ list: "ordered" }, { list: "bullet" }, { list: "check" }, { color: [] }, { background: [] },],
            ["emoji"]
            ],
            editorSettings: {
                modules: {
                "emoji-toolbar": true,
                "emoji-textarea": false,
                "emoji-shortname": false,
                },
            }
        };
    },
    components: { EmptyState, VueEditor }
}
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

h3{
    font-weight: 600;
    font-size: 18px;
    color: $black;
    margin: 12px 0;
    @media screen and (max-width: $bpSmall){
        font-size: 16px;
    }
}

.backroute{
    margin-bottom: 24px;
    width: fit-content;
    display: flex;
    align-items: center;
    gap: 2px;
    color: $green;
    font-size: 13px; 
    font-weight: 600;
    cursor: pointer;
    .material-icons{
        font-size: 18px;
    }
}

.user-info{
    width: 100%;
    padding: 16px;
    margin-bottom: 32px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    gap: 24px;
    background: #fff;
    border-radius: 8px;
    color: $black;
    font-size: 14px;
    font-weight: 400;
    @media screen and (max-width: $bpBig){
        align-items: flex-start;
    }
    &__name{
        width: 50%;
        @media screen and (max-width: $bpMedium){
            width: 100%;
        }
    }
    &__mail{
        width: 50%;
        @media screen and (max-width: $bpMedium){
            width: 100%;
        }
    }
    &__attaches{
        width: 100%;
        display: flex;
        align-items: center;
        gap: 6px;
        @media screen and (max-width: $bpMedium){
            width: 100%;
        }
        .files{
            font-weight: 600;
            font-size: 14px;
            display: flex;
            align-items: center;
            color: $green;
            gap: 12px;
            @media screen and (max-width: $bpMedium) {
                font-size: 12px;
            }
            a{
                display: flex;
                align-items: center;
            }
            .material-icons{
                font-size: 17px;
            }
        }
    }
}

.submissions,.last-submission{
    width: 100%;
    margin-bottom: 32px;
    @include flex-column;
    align-items: flex-start;
    gap: 24px;
    h3{
        width: 100%;
        color: $green;
    }
    >div{
        width: 100%;
        //border-bottom: 1px solid $black;
        max-height: 300px;
        overflow-y: auto;
        &:last-child{
            border: none;
        }
    }
    .files{
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        a{
            padding: 7px 14px;
            display: flex;
            align-items: center;
            background: $green;
            color: #fff;
            border-radius: 16px;
            i{
                font-size: 17px;
            }
            span{
                text-decoration: underline;
                font-size: 14px;
            }
        }
    }
}

.history__status{
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    color: $black;
    span{
        font-weight: 600;
        @media screen and (max-width: $bpSmall){
            font-size: 16px;
            text-align: center;
        }
        strong{
            margin-left: 8px;
            font-weight: 400;
            color: $red;
        }
        .open{
            color: $green;
        }
    }
}

.user-info__status{
    display: flex;
    align-items: center;
    gap: 6px;
    span:last-child{
        font-weight: 400;
        font-size: 12px;
        color: $darkgray;   
    }
}

.history__container{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 16px;
    width: calc(100%-24px);
    margin: 24px;
    @media screen and (max-width: $bpBig){
        margin: 12px;
    }
    .history__component{
        padding: 10px 24px 10px;
        background-color: $lightgray;
        border-radius: 10px;
        width: 40%;
        color: $black;
        @media screen and (max-width: $bpBig){
            width: 100%;
        }
        &.feedback {
            align-self: flex-end;
        }

        .history__message {
            white-space: wrap;
        }
    }
    .history__autor{
        font-weight: 600;
        font-size: 13px;
        color: $green;
    }
    .history__submission{
        font-weight: 400;
        margin-top: 4px;
        font-size: 13px;
    }
    .history__date{
        font-weight: 500;
        font-size: 11px;
        color: $darkgray;
        margin-left: 6px;
    }
    .history__newAttach{
        background-color: $lightgray;
        color: $black;
        margin: -10px -24px -10px;
        padding: 10px 24px 10px;
        border-radius: 10px;
        font-weight: 500;
        font-size: 12.5px;
        strong{
            color: $green;
        }
        .history__date{
            font-weight: 400;
        }
        .history__attach{
            display: flex;
            align-items: center;
            .files{
                gap: 0;
                font-weight: 600;   
                display: flex;
                flex-direction: column;
                padding: 0;
                margin-top: 6px;
                span{
                    font-size: 12px;
                }
                a{
                    color: $black;
                    padding:0;
                    background-color: inherit;
                }
            }
        }
    }
}

.history__form{
    border: none;
    width: 100%;
    padding: 12px 17px;
    display: flex; 
    justify-contenT: space-between;
    textarea{
        border: none;
        outline: none;
    }
    .history__text{
        border: none;
        width: 80%;
        margin-left: 14px;
        resize: none;
        height: 70px;
        outline: none;
    }
    .history__sendBtn{
        background: #009696;
        color: #fff;
        padding: 8px 16px;
        border-radius: 44px;
        font-weight: 600;
    }
}

.history__notContent{
    margin: 21px;
    display: flex;
    justify-content: center;
    font-weight: 400;
    opacity: 0.7;
}

.new-feedback{
    width: 100%;
    //max-width: 450px;
    h4{
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 13px;
        font-weight: 500;
        .material-icons{
            font-size: 18px;
        }
    }
    textarea{
        width: 100%;
        height: 80px;
        padding: 6px;
        resize: none;
        border-radius: 4px;
    }
    &__actions{
        padding: 0;
        padding-top: 16px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 12px;
        button{
            padding: 12px 28px;
            border-radius: 44px;
            color: $green;
            font-weight: 600;
            font-size: 14px;
            display: flex;
            align-items: center;
            gap: 6px;
            .material-icons-outlined{
                font-size: 14px;
            }
            &.confirm{
                background: $green;
                color: #fff;
            }
        }
        }
    }

.last-submission{
    >div{
        >div{
            height: fit-content;
            padding: 16px 0;
            display: flex;
            align-items: center;
            >span,div{
                padding: 0 24px;
            }
            span:first-child{
                //padding: 12px;
                font-weight: 600;
            }
        }
    }
    .feedback{
        display: flex;
        align-items: center;
        text-align: justify;
        .material-icons{
            margin-left: 8px;
            padding: 8px;
            font-size: 30px;
            border-radius: 10px;
            box-shadow: 0px 0px 8px -4px rgba(125,125,125,0.6);
            cursor: pointer;
        }
    }
}

@media screen and (max-width: $bpBig){
    .user-info{
        flex-direction: column;
        font-size: 11px;
    }

    .last-submission > div > div{
        flex-direction: column;
        gap: 10px;
        overflow-y: auto;
        span{
            align-self: flex-start
        }
    }
}
</style>